import { render, staticRenderFns } from "./fileUpload.vue?vue&type=template&id=148a7c82&scoped=true&"
import script from "./fileUpload.vue?vue&type=script&lang=js&"
export * from "./fileUpload.vue?vue&type=script&lang=js&"
import style0 from "./fileUpload.vue?vue&type=style&index=0&id=148a7c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a7c82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('148a7c82')) {
      api.createRecord('148a7c82', component.options)
    } else {
      api.reload('148a7c82', component.options)
    }
    module.hot.accept("./fileUpload.vue?vue&type=template&id=148a7c82&scoped=true&", function () {
      api.rerender('148a7c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/fileUpload.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/fileUpload.vue
// module id = fbU1
// module chunks = 0